export default "__VITE_ASSET__CPf2WC7c__"